// export const BASE_URL = "http://13.229.46.9:10001/webapi";
// export const BASE_URL = "https://dev-api-coldchain.we-io.com/webapi";
// export const BASE_URL = "https://qa-api-coldchain.we-io.com/webapi";
export const BASE_URL = "https://api-coldchain.we-io.com/webapi";
// export const BASE_URL = "https://api-coldchain.we-io.com/webapi";
export const BASE_URL_FAST = "https://api-coldchain.we-io.com/webapi";

export const GOOGLE_MAP_KEY = "AIzaSyAmjEn7OoUoj3EPApR7SvqCWxamJJAb6ig";
// export const GOOGLE_MAP_KEY = "AIzaSyDNwWt4rwJJ953rjpfYPJwoYYfq-JYYZ1A";

